import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { HeaderPage } from 'components';
import { TablaGeneracionEnlaces } from './components/TablaGeneracionEnlaces';
import './GeneracionEnlaces.scss';
import { BuscadorGeneracionEnlaces } from './components/BuscadorGeneracionEnlaces';

export function GeneracionEnlaces() {
  // eslint-disable-next-line no-unused-vars
  const [mainFilters, setMainFilters] = useState({});

  return (
    <div className="generacion-enlaces">
      <Row>
        <Col span={18}>
          <HeaderPage
            section="Descargas"
            section2="Generación de enlaces"
            title="Generación de enlaces"
            header="Selecciona al menos un campo para realizar la búsqueda."
          />
        </Col>
      </Row>

      <BuscadorGeneracionEnlaces onSearch={setMainFilters} />

      <TablaGeneracionEnlaces mainFilters={mainFilters} />
    </div>
  );
}

export default GeneracionEnlaces;
